import api from './api';
import { StatisticsFilters, filtersToParams } from '../utils/period';

/**
 * Admin statistics API. Every call takes the same period + campus filters.
 * The axios interceptor unwraps the response, so these resolve to `data`.
 */

async function get(path: string, filters: StatisticsFilters, extra: Record<string, string> = {}) {
  const response = await api.get(`/statistics/${path}`, { params: { ...filtersToParams(filters), ...extra } });
  return response.data;
}

export const getOverview = (filters: StatisticsFilters) => get('overview', filters);

/** scope 'upcoming' = rides still to depart (from now on); the period then doesn't apply to rides. */
export const getMarketplace = (
  filters: StatisticsFilters,
  route?: { origin: string; destination: string } | null,
  scope: 'period' | 'upcoming' = 'period'
) =>
  get('marketplace', filters, {
    ...(route ? { origin: route.origin, destination: route.destination } : {}),
    ...(scope === 'upcoming' ? { scope } : {}),
  });

export const getCaptures = (filters: StatisticsFilters) => get('captures', filters);

export const getGrowth = (filters: StatisticsFilters) => get('growth', filters);

export const getTrust = (filters: StatisticsFilters) => get('trust', filters);

export const getCampuses = async (): Promise<{ id: string; name: string; members: number }[]> => {
  const response = await api.get('/statistics/campuses');
  return response.data.items;
};

export const getDrilldown = (filters: StatisticsFilters, metric: string, page: number, limit = 50) =>
  get(`drilldown/${encodeURIComponent(metric)}`, filters, { page: String(page), limit: String(limit) });

/** Every row behind a figure, as the CSV file the server builds. */
export async function downloadDrilldownCsv(filters: StatisticsFilters, metric: string): Promise<Blob> {
  return api.get(`/statistics/drilldown/${encodeURIComponent(metric)}`, {
    params: { ...filtersToParams(filters), format: 'csv' },
    responseType: 'blob',
  });
}

/** The server's error message, wherever axios put it. */
export function errorMessage(err: any, fallback: string): string {
  return err?.response?.data?.message || err?.message || fallback;
}
